<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre sigil_not_in_toc" id="calibre_pb_2"><a class="calibre1" id="Image_002"><img alt="image002" class="calibre8" id="id-1436881280306497557" src="Images/img0001.jpg"/></a></h2>
<h4 class="calibre9 sigil_not_in_toc" id="pgepubid00000">"I shouldn't wonder, but I ought to know you, sir," he said.</h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?aafd55b0